import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import FieldProcessorTable from "./FieldProcessorTable";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  onClose: () => void;
}

const FieldProcessorModal: React.FC<Props> = ({ open, onClose }) => {
 return (
   <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
     <DialogTitle
       style={{
         display: "flex",
         justifyContent: "space-between",
         alignItems: "center",
       }}
     >
       Field Processor Users
       <IconButton onClick={onClose}>
         <CloseIcon />
       </IconButton>
     </DialogTitle>

     <DialogContent>
       <FieldProcessorTable />
     </DialogContent>
   </Dialog>
 );
};

export default FieldProcessorModal;
